import { defineModelFactory } from '@/app/libs/I';

export type GlobalModel = {
  path: string,
}

/**
 * @deprecated legacy
 */
export const globalModel = defineModelFactory<GlobalModel>()({});
